export default __webpack_public_path__ + "static/using-different-microservice-client-libraries-81c90f7523c2ba9d3a6e16139899a6a9.webp";